import React from 'react';
const logo = require('./logo.svg');

export function TwitterButton(props: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
    return (
        <a {...props} className="button is-twitter is-black">
            <span className="icon is-small">
                <img src={logo} />
            </span>
        </a>
    );
}
